export const parameterHeading = [
  'Sample Replicate', 'Well ID', 'Labware Type', 'Tip Type', 'AQ Labware', 'AQ Well',
  'Mixing Cycles', 'Encapsulation Speed', 'Dilution Speed', 'LNP Plate Barcode'
];

export const parameterIgniteHeading = [
  'Sample Name', 'Labware Type - storage vessel', 'Mixer Type', 'NanoAssemblr Ignite NxGen Cartridge Type', 
  'Syringe Payload Phase - Brand', 'Syringe Payload Phase - Volume (mL)', 'Syringe Encapsulant Phase - Brand', 
  'Syringe Encapsulant phase - Volume (mL)', 'Syringe Dilution buffer - Brand', 'Syringe Dilution Buffer - Volume (mL)', 
  'Flow Rate Ratio C - Payload phase to encapsulant phase', 'Flow Rate Ratio R - Encapsulant phase to payload phase', 
  'Total Volume (mL)', 'Start waste (mL)', 'End waste (mL)',
];

// CPI & UoS Tab Analysis Table Headings 
export const ribogreenHeading = [
  'Sample Replicate', 'RG Plate', 'Well', 'Buffer', 'Raw FI', 'Curve m value', 
  'Curve c value', 'Curve r2 value', 'Sample Conc (μg/mL)', 'Expected Sample Conc (μg/mL)', 
  'Recovery (%)', 'EE (%)', 'Storage Condition', 'Time Point',
];

export const dlsSummaryHeading = [
  'Sample Replicate', 'Item', 'Data Quality', 'Intensity (Cnt/s)', 'Normalized Intensity (Cnt/s)', 
  'Well', 'Radius (nm)', 'Amplitude', 'Diffusion Coefficient (cm/s)', 'Diameter (nm)', 
  'Polydispersity (nm)', '%PD', 'PD Index', 'Storage Condition', 'Time Point',
];

//MDC Tab Analysis Table Headings
export const transfectionHeading = [
  'Sample replicate', 'Barcode', 'Row', 'Column', 'Cells number objects', 'Transfection efficiency', 'Number analyzed fields', 
  'Condition', 'Concentration', 'Field correction', 'Avg cells number objects pos neg ctrls', 'Cells number percentage change', 
  'Green cells intensity mean normalised', 'Well', 'Plate ng', 'Storage Conditions', 'Time Point',
];

export const siRNAtransfectionHeading = [
  'Sample replicate', 'Barcode', 'Row', 'Column', 'Cells number objects', 'Transfection efficiency', 'Number analyzed fields', 
  'Condition', 'Concentration', 'Field correction', 'Avg cells number objects pos neg ctrls', 'Cells number percentage change', 
  'Total fluorescence over cell number normalised', 'Well', 'Plate ng', 'Storage Conditions', 'Time Point',
];

export const potencyTEHeading = [
  'LNP identifier', 'LNP Formulation', 'Cell Line', 'Biological replicate', 'Date of assay set up', 
  'MAX (100%) transfection reached?', 'Half maximal effective dose (ED50) [ng of mRNA per well]', 
  'Dose [ng/well]', 'Notes',
];

export const potencyTEMetricsHeading = [
  'Cell number - change from control [%] - replicate', 'Transfection efficiency [%] - replicate', 
  'Median fluorescence per cell (normalised) - replicate', 
];

export const endosomalRuptureHeading = [
  'LNP identifier', 'LNP Formulation', 'Biological replicate', 'Date of assay set up', 'Time [h]', 'Notes', 
  'Cell number - change from control [%] - replicate 1', 'Uptake - spot count per cell replicate 1', 'Uptake - spot median fluorescence intensity per cell replicate 1', 
  'Endosomal rupture - spot count per cell (normalised) replicate 1', 'Endosomal rupture - spot median fluorescence intensity per cell (normalised) replicate 1', 
  'Expression - Transfection efficiency replicate 1', 'Expression - median fluorescence intensity per cell (normalised) replicate 1',
  'Cell number - change from control [%] - replicate 2', 'Uptake - spot count per cell replicate 2', 'Uptake - spot median fluorescence intensity per cell replicate 2', 
  'Endosomal rupture - spot count per cell (normalised) replicate 2', 'Endosomal rupture - spot median fluorescence intensity per cell (normalised) replicate 2', 
  'Expression - Transfection efficiency replicate 2', 'Expression - median fluorescence intensity per cell (normalised) replicate 2',
  'Cell number - change from control [%] - replicate 3', 'Uptake - spot count per cell replicate 3', 'Uptake - spot median fluorescence intensity per cell replicate 3', 
  'Endosomal rupture - spot count per cell (normalised) replicate 3', 'Endosomal rupture - spot median fluorescence intensity per cell (normalised) replicate 3', 
  'Expression - Transfection efficiency replicate 3', 'Expression - median fluorescence intensity per cell (normalised) replicate 3',
];

export const biodistributionInVivoHeading = [
  'LNP identifier', 'LNP labelling', 'Injection route', 'LNP buffer', 'Concentration/mRNA dose [ug]', 'In vivo study number', 
  'In vivo Imaging time point [hour]', 'Animal Number', 'In vivo ROI number', 'In vivo ROI size [cm/sr]', 'In vivo DiR Total Radiant Efficiency [p/s] / [W/cm]', 
  'In vivo DiR Avg Radiant Efficiency [p/s/cm/sr] / [W/cm]', 'Control ROI size [cm/sr]', 'Control Total Radiant Efficiency [p/s] / [W/cm]', 
  'Control Avg Radiant Efficiency [p/s/cm/sr] / [W/cm]', 'In vivo DiR fold change relative to control', 'Note',
];

export const biodistributionExVivoHeading = [
  'LNP identifier', 'LNP labelling', 'Injection route', 'LNP buffer', 'Concentration/mRNA dose [ug]', 'In vivo study number', 
  'Ex vivo time point [hour]', 'Animal Number',  'Cardiac perfusion buffer', 'Cardiac perfusion volume', 'Organ name', 'Ex vivo ROI number', 
  'Ex vivo DiR ROI size [cm/sr]', 'Ex vivo DiR Total Radiant Efficiency [p/s] / [W/cm]', 'Ex vivo DiR Avg Radiant Efficiency [p/s/cm/sr] / [W/cm]', 
  'Control DiR ROI size [cm/sr]', 'Control DiR Total Radiant Efficiency [p/s] / [W/cm]', 'Control DiR Avg Radiant Efficiency [p/s/cm/sr] / [W/cm]', 
  'Ex vivo DiR fold change relative to control', 'Ex vivo mGL ROI size [cm/sr]', 'Ex vivo mGL Total Radiant Efficiency [p/s] / [W/cm]', 
  'Ex vivo mGL Avg Radiant Efficiency [p/s/cm/sr] / [W/cm]', 'Control mGL ROI size [cm/sr]', 'Control mGL Total Radiant Efficiency [p/s] / [W/cm]', 
  'Control mGL Avg Radiant Efficiency [p/s/cm/sr] / [W/cm]', 'Ex vivo mGL fold change relative to control', 'Note',
];

export const mRNAExpressionExVivoWholeTissueHeading = [
  'LNP identifier', 'LNP labelling', 'Injection route', 'Concentration/mRNA dose [ug]', 'LNP buffer', 'In vivo study number', 
  'Animal Number', 'Ex vivo time point [hour]', 'Cardiac perfusion buffer', 'Cardiac perfusion volume', 'Organ name', 
  'Whole tissue mGL quantification - DAPI mean fluorescence intensity (DAPI_MFI)', 
  'Whole tissue mGL quantification -  DAPI adjusted fluorescence intensity (DAPI_AFI)', 
  'Whole tissue mGL quantification - AF488 mean fluorescence intensity (mGL_MFI)', 
  'Whole tissue mGL quantification - AF488 adjusted fluorescence intensity (mGL_AFI)', 
  'Whole tissue mGL quantification - AF488 fluorescence intensity fold change to control (mGL_FC)', 'Note'
];

export const mRNAExpressionExVivoCellTypeSpecificHeading = [
  'LNP identifier', 'LNP labelling', 'Injection route', 'Concentration/mRNA dose [ug]', 'LNP buffer', 'In vivo study number', 
  'Animal Number', 'Ex vivo time point [hour]', 'Cardiac perfusion buffer', 'Cardiac perfusion volume', 'Organ name', 'Cell type', 
  'Cell type area ratio', 'Background mean fluorescence intensity (BG_AF488)', 
  'Background fluorescence intensity relative fold change (BG_AF488_FC)', 'Cell marker mean fluorescence intensity (AF568_MFI)', 
  'Cell marker adjusted fluorescence intensity (AF568_AFI)', 'mGL mean fluorescence intensity (AF647_MFI)', 
  'mGL adjusted fluorescence intensity (AF647_AFI)', 'mGL fluorescence intensity fold change to control (AF647_FC)', 
  'mGL total fluorescence intensity (AF647_TFI)', 'mGL total fluorescence intensity fold change (AF647_TFI_FC)', 
  'mGL expression positivity rate (%)', 'Note'
];

export const mechanismOfInternalizationHeading = [
  'LNP identifier', 'LNP Formulation', 'Biological replicate', 'Date of assay set up', 'Dose [ng/well]', 'Time point (h)', 'Notes',
];

export const mechanismOfInternalizationMetricsHeading = [
  'CME internalization pathway knckdown using siCLTC _ Cell number - change from control [%] - replicate', 
  'CME internalization pathway knckdown using siCLTC_Transfection efficiency [%] - replicate', 
  'CME internalization pathway knckdown using siCLTC_Mean fluorescence per cell (normalised) - replicate', 
  'CME internalization pathway control siC _ Cell number - change from control [%] - replicate', 
  'CME internalization pathway control siC_Transfection efficiency [%] - replicate', 
  'CME internalization pathway control siC_Mean fluorescence per cell (normalised) - replicate',
];

// UoLTab Analysis Table Headings
export const dlsHeading = [
  'LNP Identifier', 'Make/Model', 'Scattering Angle', 'Wavelength', 'Material Refractive Index', 
  'Dispersant', 'Dispersant Refractive Index', 'Dispersant Viscosity (25°C)', 'Cell type', 'Date Measured', 
  'Site measured', 'Date Received', 'Freeze thaw cycles', 'Comments',
];

export const dlsRunHeading = ['Size', 'PDI', 'Modality',];

export const lalHeading = [
  'LNP Identifier', 'Date Measured', 'Date Received', 'Freeze-thaw cycles', 'Dilution factor', 
  'Test Concentration (ng/mL)', 'Spike Recovery (%)', 'Pass/Fail',
];

export const cytotoxicityHeading = [
  'LNP Identifier', 'Date Measured', 'Date Received', 'Freeze-thaw cycles', 
  'Cell Line', 'WST1 CC20 (ng/mL)', 'LDH CC20 (ng/mL)',
];

export const ku812Heading = [
  'LNP Identifier', 'Date Received', 'Date Tested', 'Freeze-thaw cycles', 'Test Concentration (ug/mL)', 
  'CD63 - Mean % of -Ve Control', 'CD63 - %CV', 'CD203c - Mean % of -Ve Control', 'CD203c - %CV', 
  'CD164 - Mean % of -Ve Control', 'CD164 - %CV',
];

export const coagulationHeading = [
  'LNP Identifier', 'Date Received', 'Date Tested', 'Material Freeze-thaw cycles', 
  'Plasma Type', 'Test Concentration (ug/mL)', 'Comments', 'Untreated PT Mean',
  'Untreated TT Mean', 'Untreated aPTT Mean', 'Treated PT Mean', 'Treated TT Mean',
  'Treated aPTT Mean', 'PT difference', 'TT difference', 'aPTT difference',
];

export const complementHeading = [
  'LNP Identifier', 'Date Received', 'Material Freeze-thaw cycles', 'Analyte','Test Concentration (ug/mL)',
  'Mean % of negative control (Untreated)', 'Date Tested 1', '% of negative control (Untreated) - Replicate 1', 
  '% of negative control (Untreated) - Replicate 2', 'Date Tested 2', '% of negative control (Untreated) - Replicate 3', 
  '% of negative control (Untreated) - Replicate 4',
];

export const coagulationMetricsHeading = [
  'Untreated PT Replicate', 'Untreated TT Replicate', 'Untreated aPTT Replicate', 
  'Treated PT Replicate', 'Treated TT Replicate', 'Treated aPTT Replicate',
];

// UoSTab Analysis Table Headings
export const zetaPotentialHeading = [
  'LNP Identifier', 'Make/Model', 'Scattering Angle', 'Wavelength', 'Material Refractive Index', 
  'Dispersant', 'Dispersant Refractive Index', 'Dispersant Viscosity (25°C)', 'Cell type', 'Date Measured', 
  'Site measured', 'Date Received', 'Freeze thaw cycles', 'Comments',
];

export const zetaPotentialRunHeading = ['ZP'];